
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/poddar/guide",
      function () {
        return require("private-next-pages/poddar/guide.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/poddar/guide"])
      });
    }
  